import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';

import { ModalState, OpenModalPayload } from './modalSlice.types';

const initialModalState: ModalState = {
  drag: false,
  hideClose: false,
  hideCloseButton: false,
  isOpen: false,
  modalName: null,
  params: null,
  size: 'base'
};

const modalSlice = createSlice({
  initialState: initialModalState,
  name: 'modal',
  reducers: {
    changeModalSize: (
      state,
      action: PayloadAction<{
        size: 'sm' | 'base' | 'lg' | 'xl';
      }>
    ) => {
      state.size = action.payload.size || 'base';
    },
    closeModal: (state, action: PayloadAction<{ funcOnClose?: () => void } | undefined>) => {
      action.payload?.funcOnClose?.();
      state.isOpen = false;
      state.hideClose = false;
      state.modalName = null;
      state.params = null;
      state.size = 'base';
      state.drag = false;
      state.hideCloseButton = false;
      state.classNames = null;
    },
    openModal: (state, action: PayloadAction<OpenModalPayload>) => {
      state.isOpen = true;
      state.hideClose = !!action.payload.hideClose;
      state.modalName = action.payload.modalName;
      state.params = action.payload.params;
      state.size = action.payload.size || 'base';
      state.drag = !!action.payload.drag;
      state.hideCloseButton = !!action.payload.hideCloseButton;
      state.classNames = action.payload.classNames || null;
    }
  }
});

export const selectModal = (state: RootState) => state.modal;

export const { changeModalSize, closeModal, openModal } = modalSlice.actions;

export default modalSlice.reducer;
